import React from 'react';

const WarningSVG = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.95312 0.500857C8.78462 0.508258 8.62077 0.55695 8.47677 0.642414C8.33277 0.727878 8.21327 0.847345 8.12936 0.989741L0.13287 14.4713C0.0453947 14.6197 -0.000428239 14.7878 3.0161e-06 14.9588C0.000434271 15.1299 0.0471045 15.2978 0.135327 15.4458C0.223549 15.5937 0.350216 15.7164 0.502608 15.8017C0.655 15.8869 0.82775 15.9316 1.00351 15.9313H16.9965C17.1723 15.9316 17.345 15.8869 17.4974 15.8017C17.6498 15.7164 17.7765 15.5937 17.8647 15.4458C17.9529 15.2978 17.9996 15.1299 18 14.9588C18.0004 14.7878 17.9546 14.6197 17.8671 14.4713L9.86394 0.989741C9.77267 0.834903 9.63946 0.707434 9.47885 0.621224C9.31823 0.535014 9.13638 0.493375 8.95312 0.500857ZM9 4.78708C9.47344 4.78708 9.85725 5.17089 9.85725 5.64433L9.64293 9.50195C9.64293 9.85702 9.35508 10.1449 9 10.1449C8.64492 10.1449 8.35707 9.85702 8.35707 9.50195L8.14275 5.64433C8.14275 5.17089 8.52656 4.78708 9 4.78708ZM9 11.2164C9.5918 11.2164 10.0716 11.6962 10.0716 12.288C10.0716 12.8798 9.5918 13.3596 9 13.3596C8.4082 13.3596 7.92844 12.8798 7.92844 12.288C7.92844 11.6962 8.4082 11.2164 9 11.2164Z"
      fill="#A05600"
    />
  </svg>
);

export { WarningSVG };
